module.exports = __webpack_public_path__ + "img/disabledownload.c0a9e8a0.svg";